class ClickHandler<TEvent extends Event> {
    private _click: ((e: TEvent) => any) | null = null;
    private _dblclick: ((e: TEvent) => any) | null = null;

    private _touchTime = 0;
    private _clickedTimes = 1;

    constructor() {
    }
    call(event: TEvent) {
        var currTouchTime = new Date().getTime();
        if ((currTouchTime - this._touchTime) < 800)
            this._clickedTimes += 1;
        else
            this._clickedTimes = 1;
        
        if (this._clickedTimes == 1 && this._click != null)
            this._click(event);
        if (this._clickedTimes == 2 && this._dblclick != null)
            this._dblclick(event);

        this._touchTime = currTouchTime;
    }
    click(func: (e: TEvent) => any) {
        this._click = func;
        return this;
    }
    dblclick(func: (e: TEvent) => any) {
        this._dblclick = func;
        return this;
    }
}